// extracted by mini-css-extract-plugin
export default {"switch":"ThemeChanger_switch__6MRQt","slider":"ThemeChanger_slider__GGcAn"};